// JSA values are stored in English (job type, risk level, signature role)
// so records, PDFs and reports stay consistent. These translate them for
// display only; anything not in the list (a custom role, an old job type)
// is shown as typed.
export const JOB_TYPES = {
  Workover: "workover",
  Completion: "completion",
  "Plug & Abandon": "plugAbandon",
  Swabbing: "swabbing",
  "Rod Pump Service": "rodPump",
  "ESP Service": "esp",
  Fishing: "fishing",
  Cementing: "cementing",
  Perforating: "perforating",
  "Acidizing / Stimulation": "acidizing",
  "Wireline (Through Tubing) Ops": "wireline",
};

export const RISK_LEVELS = ["Low", "Medium", "High", "Critical"];

export const PRESET_ROLES = {
  Supervisor: "supervisor",
  "Tool Pusher": "toolPusher",
  "Safety Officer": "safetyOfficer",
  "Crew Member": "crewMember",
  "Company Rep": "companyRep",
  Contractor: "contractor",
};

export function jobTypeLabel(t, value) {
  const key = JOB_TYPES[value];
  return key ? t(`jsa.jobTypes.${key}`) : value;
}

export function riskLabel(t, value) {
  return RISK_LEVELS.includes(value) ? t(`jsa.risk.${value}`) : value;
}

export function roleLabel(t, value) {
  const key = PRESET_ROLES[value];
  return key ? t(`jsa.roles.${key}`) : value;
}
